import { isNotEmpty } from "@neru/utils";
import type { ReactNode } from "react";

import { Icon } from "../Icon";
import { Phrase } from "../Phrase/Phrase";
import { Row } from "../Row/Row";

interface BreadcrumbsProps {
  children: Array<ReactNode>;
}

export const Breadcrumbs = ({ children }: BreadcrumbsProps) => {
  const filteredChildren = children
    .filter(isNotEmpty)
    .map((item) => <Phrase key={item?.toString()}>{item}</Phrase>);

  const list: Array<() => ReactNode> = [];
  filteredChildren.forEach((item, index) => {
    list.push(() => item);
    if (index < filteredChildren.length - 1) {
      list.push(() => (
        <div className="mx-3 inline-flex align-middle">
          <Icon
            className="fill-primary-500"
            customSize={12}
            type="chevron-right-solid"
          />
        </div>
      ));
    }
  });

  return (
    <Row className="mb-4 items-center" data-testid="breadcrumbs">
      {list.map((Item, index) => (
        <Item key={index} />
      ))}
    </Row>
  );
};
